export const easing = {
  ping: 'cubic-bezier(.79, 0, .27, .92)',
  move: 'cubic-bezier(.47, .01, .33, .94)',
  snapPing: 'cubic-bezier(.85, -0.17, .27, .92)',
}
